export default "__VITE_ASSET__CI$VfzIs__"